import useFlowInputComponent from '@flows/src/hooks/useFlowsInputComponent';
import { FlowsQuestion } from '@flows/src/types/FlowsTypes';
import { FC } from 'react';

interface Props {
  question: FlowsQuestion;
}

/**
 * This component makes sure the logic of the FlowInputComponent is executed but doesn't show the input
 */
const HiddenInputComponent: FC<Props> = ({ question }) => {
  useFlowInputComponent({ question });

  return null;
};

export default HiddenInputComponent;
